import { useDispatch, useSelector } from "react-redux"
import { useState } from "react"
import { verifyOtpAction, otpData } from "../../stores/auth"

const useOtpInput = () => {
    const dispatch = useDispatch()
    const { status, error } = useSelector(otpData)

    const baseUrl = process.env.REACT_APP_BASEURL
    const [otp, setOtp] = useState("")

    const handleChangeOtp = (value) => {
        setOtp(value)
    }

    const handleSubmit = (e) => {
        e.preventDefault()

        if (otp.length !== 6) return

        dispatch(
            verifyOtpAction({
                otp,
                token: localStorage.getItem("otp_token"),
            })
        )
    }

    return {
        otp,
        baseUrl,
        status,
        error,
        handleChangeOtp,
        handleSubmit,
    }
}

export default useOtpInput
